import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=f74939a2&scoped=true&"
import script from "./StudentInfo.vue?vue&type=script&lang=js&"
export * from "./StudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&id=f74939a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74939a2",
  null
  
)

export default component.exports